import React from 'react'
import MainContent from './MainContent'
import Sidebar from './Sidebar/NewSidebar'
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import Cookies from 'js-cookie'
import { SendBlogLink, FetchStartupDetailsByID } from 'api/profile'
import { useDispatch } from 'react-redux'
import { SET_INVESTOR_TYPES, SET_STARTUP_DETAILS } from 'store/actions'
import PermissionsHandler from 'handlers/PermissionHandler'
import { FetchAllInvestorTypes, FetchAllUTMCampaignList } from 'api/utils'
import { FetchAllResources } from 'api/resources'
import ProgressHandler from 'handlers/ProgressHandler'
import ScoreChangeBanner from './ScoreChangeBanner'
import { checkForAuthorization, handleLogout } from 'utilities/index'
import DetailsHandler from 'handlers/DetailsHandler'
import { useToast } from 'context/ToastContext'
import theme from 'themes/theme'
import { useAppSession } from 'hooks/useAppSession'

const MainLayout = () => {
    const { addToast } = useToast();
    let [startup_id, setStartupID] = React.useState(Cookies.get("X-ST-ID") || null);
    const isProfileComplete = Cookies.get("is_profile_complete") === "true" ? true : false;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const currentIP = window.location.host;
    const currentBackground = document.getElementsByTagName("body");
    currentBackground[0].style.backgroundColor = theme.palette.customColors.black;
    const { data: userData, isLoading: isLoadingUserData, refetch: refetchStartupDetails, isRefetching } = FetchStartupDetailsByID({ startup_id });
    const { data: investor_types_data, isLoading: isLoadingInvestorTypesData } = FetchAllInvestorTypes();
    // const { data: utm_campaign_list, isLoading: isLoadingAllUTMCampaignList } = FetchAllUTMCampaignList();
    // const { data: resources, isLoading: isLoadingResources } = FetchAllResources();
    const {
        mutateAsync: sendBlogLink,
        status: AddStartupStatus,
        error: AddStartupError,
        isLoading: isUpdating,
        data: AddStartupResponse,
    } = SendBlogLink();

    React.useEffect(() => {
        if (!isLoadingInvestorTypesData && investor_types_data) {
            // console.log(investor_types_data)
            dispatch({ type: SET_INVESTOR_TYPES, investor_types: investor_types_data });
        }
    }, [investor_types_data, isLoadingInvestorTypesData])

    React.useEffect(() => {
        // console.log(userData,"mesage")
        if (userData?.data && !isLoadingUserData && !isRefetching) {
            // console.log(userData?.data,"userData?.data")
            dispatch({ type: SET_STARTUP_DETAILS, data: userData?.data });
        }
    }, [isLoadingUserData, userData?.data, isRefetching])

    console.log(isProfileComplete, "isProfileComplete")

    // Founder app usage for the admin Active Users / Session Time analytics.
    useAppSession(startup_id);

    const hasLoggedOut = React.useRef(false);
    const isSignedOut = !Cookies.get("X-ST-ID");

    React.useEffect(() => {
        if (!isSignedOut || hasLoggedOut.current) return;
        hasLoggedOut.current = true;

        handleLogout({
            dispatch,
            navigate,
            location: { pathname: window.location.pathname },
        });
    }, [isSignedOut, dispatch, navigate])

    React.useEffect(() => {
        refetchStartupDetails()
    }, [navigate])

    const utm_campaign = searchParams.get("utm_campaign");

    React.useEffect(() => {
        if (
            // !isLoadingAllUTMCampaignList &&
            startup_id &&
            checkForAuthorization() &&
            utm_campaign 
            // &&
            // && utm_campaign_list
        ) {
            // if (Object.prototype.hasOwnProperty.call(utm_campaign_list, utm_campaign)) {
                const payload = {
                    utm_campaign,
                    startup: {
                        email: userData?.data?.email,
                        first_name: "Startup",
                        startup_id
                    }
                }
                sendBlogLink(payload).then((response) => {
                    if(response?.data?.success === true){
                        addToast("The blog link has been sent via email", "success");
                    }
                    setSearchParams(prev => {
                        const next = new URLSearchParams(prev);
                        next.delete("utm_campaign");
                        return next;
                    });
                }).catch(err => {
                    // addToast(err?.response?.data?.message, "error")
                });
            // } else {}
        }
    }, [
        utm_campaign
    ]);
    // isLoadingAllUTMCampaignList, , utm_campaign_list




    return (
        <div style={{ display: 'flex' }}>
            <DetailsHandler />
            <PermissionsHandler startup_id={startup_id} />
            <ProgressHandler startup_id={startup_id} />
            <Sidebar />
            <div style={{ flexGrow: 1 }}>
                <ScoreChangeBanner startup_id={startup_id} />
                {/* <Header /> */}
                <MainContent>
                    {/* <BreadcrumbsHeader /> */}
                    <Outlet />
                </MainContent>
            </div>
        </div>
    )
}

export default MainLayout